
export enum PaymentType{
        BalanceReplenishment = 1,
        PurchaseOfTariffPlan = 2,
        PaymentOfComission   = 3,
        PurchaseOfLot        = 4,
        PaymentOfDeposit     = 5,
        ReturnOfDeposit      = 6,
        ReturnOfComission    = 7
}

export var PaymentStatusDescription: { [key: PaymentType]: string; } = {};
PaymentStatusDescription[PaymentType.BalanceReplenishment] = "Пополнение баланса";
PaymentStatusDescription[PaymentType.PurchaseOfTariffPlan] = "Оплата тарифного плана";
PaymentStatusDescription[PaymentType.PaymentOfComission]   = "Оплата коммиссии";
PaymentStatusDescription[PaymentType.PurchaseOfLot]        = "Оплата лота";
PaymentStatusDescription[PaymentType.PaymentOfDeposit]     = "Оплата задатка по лоту";
PaymentStatusDescription[PaymentType.ReturnOfDeposit]      = "Возврат задатка";
PaymentStatusDescription[PaymentType.ReturnOfComission]    = "Возврат коммиссии";